import { Cloudinary } from "@cloudinary/url-gen";
import { format } from "@cloudinary/url-gen/actions/delivery";

import { fill, limitFit, thumbnail } from "@cloudinary/url-gen/actions/resize";
import { auto } from "@cloudinary/url-gen/qualifiers/format";

const uploadPreset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || '';
const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || '';

export const MAX_IMAGE_SIZE_MB = 10;
export const MAX_VIDEO_SIZE_MB = 100;

export const cld = new Cloudinary({
    cloud: {
        cloudName
    },
    // Disable the `?_a=` analytics param on generated URLs — it breaks Bunny's
    // server-side fetch of videoDownloadUrl (VideoCreateOne). Matches V2.
    url: {
        analytics: false
    }
});

export interface CloudinaryImageResponse {
    public_id: string,
    url: string,
    original_filename: string,
    original_extension: string,
    width: number,
    height: number,
    format: string
    // TODO: add more properties
}

export async function handleFileUpload(file: Blob, type = 'image') {
    const url = `https://api.cloudinary.com/v1_1/${encodeURIComponent(cloudName)}/${type}/upload`;
    const formData = new FormData();

    //FIXME: at some point we should introduce signed uploads
    formData.append("file", file);
    formData.append("upload_preset", uploadPreset);

    const res = await fetch(url, {
        method: "POST",
        body: formData,
    });

    const objectInfo = await res.json() as CloudinaryImageResponse;

    return objectInfo;
}

export const getArticleImageUrl = (imageId: string) => {
  return cld.image(imageId).resize(limitFit().width(1024)).delivery(format(auto())).toURL()
}

export function getImageUrl(imageId: string, height: number = 128 ) {
    if (!imageId) { return null; }
    return cld.image(imageId).resize(thumbnail().height(height)).format("png");
}

export function getTrafficDriverImageUrl(imageId: string) {
  if (!imageId) { return ''; }
  return cld.image(imageId).resize(fill().height(70).width(105)).delivery(format(auto())).toURL();
}
